import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { VehicleService } from '../vehicle.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalValidationService } from 'src/app/global-validation.service';
import { GlobalService } from 'src/app/global.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-vehicle-register',
  templateUrl: './vehicle-register.component.html',
  styleUrls: ['./vehicle-register.component.scss']
})
export class VehicleRegisterComponent implements OnInit {
  vehicle_register_from: FormGroup;
  action: string = '';
  vehicle_types: any;
  vehicle_transports: any;
  insurance_document: any = null;
  fc_document: any = null;
  loading = false;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(private formBuilder: FormBuilder, private vehicleService: VehicleService, private http: HttpService, private global: GlobalService,private sanitizer: DomSanitizer) {
    this.getCvData();
    this.vehicle_register_from = this.formBuilder.group({
      id: [null, Validators.compose([])],
      vehicle_transport_id: [null, Validators.compose([Validators.required])],
      licence_number: [null, Validators.compose([Validators.required])],
      vehicle_type_id: [null, Validators.compose([Validators.required])],
      insurance_expiry_date: [null, Validators.compose([Validators.required])],
      fc_expiry_date: [null, Validators.compose([Validators.required])],
      capacity_in_kg: [null, Validators.compose([Validators.required])],
      tray_capacity: [null, Validators.compose([Validators.required])],
      mobile: [null, Validators.compose([GlobalValidationService.checkMobileNumber])],
      driver_name: [null, Validators.compose([Validators.required])],
      insurance_document: [null],
      fc_document: [null],
      contract_starts_from : [null, Validators.compose([Validators.required])],
      contract_ends_on : [null, Validators.compose([Validators.required])],
    })

    if (this.vehicleService.get_vehicle_data_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.vehicleService.get_vehicle_data_data);
    }


    this.vehicleService.vehicleUpdate.subscribe((vehicle_data) => {
      if (vehicle_data === null) {
        this.action = 'register';
        this.vehicle_register_from.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(vehicle_data);
      }
    });

    // this.vehicleService.vehicleUpdate.subscribe((vehicle_data) => {
    //   this.setupUpdateForm(vehicle_data);
    // });

  }

  getCvData() {
    this.getVechicleTransport();
    this.getVehicleType();
  }

  getVechicleTransport() {
    this.http.getVehicleTransports().subscribe((data: VehicleTransport[]) => {
      console.log(data);
      this.vehicle_transports = data;
    }, (error) => {
      console.log(error);
    });
  }



  getVehicleType() {
    this.http.getVehicletype().subscribe((data: VehicleType[]) => {
      console.log(data);
      this.vehicle_types = data;
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(element_data) {
    console.log(element_data)
    this.http.getVehicleDetails(element_data).subscribe((element) => {
      console.log
      this.vehicle_register_from.controls['id'].setValue(element['id']);
      this.vehicle_register_from.controls['vehicle_transport_id'].setValue(element['vehicle_transport_id']);
      this.vehicle_register_from.controls['licence_number'].setValue(element['licence_number']);
      this.vehicle_register_from.controls['vehicle_type_id'].setValue(element['vehicle_type_id']);
      this.vehicle_register_from.controls['capacity_in_kg'].setValue(element['capacity_in_kg']);
      this.vehicle_register_from.controls['mobile'].setValue(element['driver_mobile']);
      this.vehicle_register_from.controls['driver_name'].setValue(element['driver_name']);
      this.vehicle_register_from.controls['tray_capacity'].setValue(element['tray_capacity']);
      this.vehicle_register_from.controls['fc_expiry_date'].setValue(element['fc_expiry_date']);
      this.vehicle_register_from.controls['insurance_expiry_date'].setValue(element['insurance_expiry_date']);
      this.vehicle_register_from.controls['contract_starts_from'].setValue(element['contract_starts_from']);
      this.vehicle_register_from.controls['contract_ends_on'].setValue(element['contract_ends_on']);
      console.log(this.insurance_document);
    });
    // this.insurance_document =  element_data['insurance_document'];
    // this.fc_document = element_data['fc_document'];
  }

  registerVehicle() {``
    const vehicle = Object.assign({}, this.vehicle_register_from.value);
    console.log(vehicle)
    if (this.fc_document != null) {
      vehicle['fc_document'] = this.fc_document;
    }
    if (this.insurance_document != null) {
      vehicle['insurance_document'] = this.insurance_document;
    }
    this.http.registerVehicle(vehicle).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.vehicle_register_from.reset();
      this.vehicleService.downloadVehicle.emit(true);
      this.vehicleService.is_display_vehicle_register_component = false
    });
  }

  insurancetoBase64(event) {
    console.log(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.insurance_document = reader.result;
      console.log(this.insurance_document);
    };
    console.log(reader.readAsDataURL(file));
  }


  fctoBase64(event) {
    console.log(event);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.fc_document = reader.result;
      console.log(this.fc_document);
    };
    console.log(reader.readAsDataURL(file));
  }


  ngOnInit() {
  }

}

export interface VehicleType {
  id: number;
  name: string;
}


export interface VehicleTransport {
  id: number;
  name: string;
}

